import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { ProgressBar } from 'react-bootstrap';
import Papa from 'papaparse';
import Select from 'react-select';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faCheckCircle } from '@fortawesome/pro-solid-svg-icons';

import EmptyState from 'components/project/empty_state';
import Ottercon from 'components/ottercon';

export default class SelectFile extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.array,
    csvRows: PropTypes.arrayOf(PropTypes.array).isRequired,
    currentDatabase: PropTypes.object,
    fileName: PropTypes.string,
    fileUploadHelpText: PropTypes.string,
    headerRow: PropTypes.arrayOf(PropTypes.string).isRequired,
    objectName: PropTypes.string,
    onCsvFileParsed: PropTypes.func.isRequired,
    onCsvFileSelected: PropTypes.func.isRequired,
    onDatabaseSelect: PropTypes.func
  }

  state = {
    firstInconsistentRow: this.findInconsistentRow(this.props.csvRows, this.props.headerRow),
    loading: false
  }

  findInconsistentRow(csvRows, headerRow) {
    const columnCount = headerRow.length;
    return csvRows.findIndex(row => row.length !== columnCount);
  }

  handleDrop = (files) => {
    if (files.length === 0) return;

    const file = files[0];
    const reader = new FileReader();
    reader.fileName = file.name;

    this.props.onCsvFileSelected(file);
    this.setState({ loading: true });

    reader.onload = (file) => {
      const csvRows = Papa.parse(file.target.result, { skipEmptyLines: true }).data;
      const headerRow = csvRows.shift();
      const firstInconsistentRow = this.findInconsistentRow(csvRows, headerRow);

      this.props.onCsvFileParsed(csvRows, headerRow, file.target.fileName);
      this.setState({ firstInconsistentRow, loading: false });
    };

    reader.readAsText(file);
  }

  render() {
    return (
      <div>
        <p>
          Files must be <strong>.CSV</strong> formatted and have a header row.&nbsp;
          {this.props.fileUploadHelpText}
        </p>
        <div className="my-5 csv-uploader">
          <Dropzone
            accept=".csv"
            multiple={false}
            onDrop={this.handleDrop}
          >
            {({ getRootProps, getInputProps }) => (
              <div className="csv-uploader-target" {...getRootProps()}>
                {this.renderDropBox()}
                <input {...getInputProps()} />
              </div>
            )}
          </Dropzone>
        </div>
        {this.renderDatabaseSelector()}
      </div>
    );
  }

  renderDatabaseSelector() {
    const { availableDatabases, currentDatabase, objectName, onDatabaseSelect } = this.props;

    if (availableDatabases != null) {
      return (
        <div>
          <h3 className="database-title">Select Database</h3>
          <p>Choose which database you would like these {objectName} to be imported into</p>
          <h5 className="database-subtitle pt-2">Database</h5>
          <Select
            className="database-select"
            classNamePrefix='database-select'
            options={availableDatabases}
            placeholder='Select Database'
            value={currentDatabase}
            onChange={onDatabaseSelect}
          />
        </div>
      );
    }
  }

  renderDropBox() {
    const { fileName } = this.props;
    const { loading } = this.state;

    if (!(loading || fileName)) {
      return (
        <EmptyState
          imageSrc="/images/project_empty_states/documents.svg"
          message="Click or drag CSV here to upload it."
        />
      );
    }

    return (
      <div className="py-5 px-4 w-100 drop-box">
        {loading && <ProgressBar active now={100} />}
        {fileName && this.renderFilePreview()}
      </div>
    );
  }

  renderFilePreview() {
    const { firstInconsistentRow } = this.state;

    return (
      <React.Fragment>
        <div className="mb-5 file-preview">
          <Ottercon ottercon="csv" size="md" />
          <div className="ml-3 title title-large">{this.props.fileName}</div>
        </div>
        {firstInconsistentRow >= 0 ? (
          <h4 className="m-0">
            <FontAwesomeIcon className="text-yellow mr-2" icon={faExclamationTriangle} size="lg" />
            Inconstancies found in row {firstInconsistentRow + 1}.&nbsp;
            This may cause mapping issues if you proceed with the import.
          </h4>
        ) : (
          <h4 className="m-0">
            <FontAwesomeIcon className="text-success mr-2" icon={faCheckCircle} size="lg" />
            {this.props.csvRows.length} records successfully detected. Click “Next” to continue.
          </h4>
        )}
      </React.Fragment>
    );
  }
}


// @options.fileLoadStarted() if @options.fileLoadStarted
// files = event.target.files
// csv = files[0]

// reader = new FileReader()
// reader.onload = (file) =>
//   @resetInputData()

//   @parseCSV(file.target.result)
//   @initMapping()
//   @buildTable()
//   @setEnumTables()

//   @options.fileLoadComplete(csv) if @options.fileLoadComplete

// reader.readAsText(csv)
